import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MessageModel } from '../types';

@Component({
  selector: 'message-file',
  templateUrl: './message-file.component.html',
  styleUrls: ['./message-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MessageFileComponent {
  @Input() message!: MessageModel;

  trackByFn(index: number): number {
    return index;
  }
}
